const RTL_LOCALES = new Set(['ar', 'fa'])

/**
 * The site itself stays left to right; the notification surfaces set their
 * own direction so Arabic and Persian read naturally inside them.
 */
export function textDirection(locale: string): 'rtl' | 'ltr' {
  return RTL_LOCALES.has(locale.split('-')[0]) ? 'rtl' : 'ltr'
}
